module.exports = __webpack_public_path__ + "static/img/use_bg.50e9512.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/use_bg.png
// module id = iD7g
// module chunks = 0